import store from '@/store'
import { Component, nextTick } from 'vue'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { useStore } from 'vuex'
const FullScreenLayout = (): Promise<Component> => import('@/views/Base/FullScreenLayout.vue')
const Layout = (): Promise<Component> => import('@/views/Base/Layout.vue')
// const Cluster =()=> import('@/views/Config/BasicConfig/Cluster.vue')
// const Dashboard =()=> import('@/views/Config/BasicConfig/Dashboard.vue')
// const Limiter =()=> import('@/views/Config/BasicConfig/Limiter.vue')

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/home/overview',
    meta: {
      hideKey: 'home',
      authRequired: true,
      subMenu: false,
    },
    children: [
      {
        path: 'overview',
        name: 'homeOverview',
        component: () => import('@/views/Dashboard/Home.vue'),
      },
      {
        path: 'bi',
        name: 'bi',
        component: () => import('@/views/DataV/NavigationPage.vue'),
      },
      {
        path: 'photovoltaicOverview',
        name: 'PhotovoltaicOverview',
        component: () => import('@/views/Dashboard/Photovoltaic/PhotovoltaicOverview.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',

    meta: {
      authRequired: false,
    },
    component: () => import('@/views/Base/Login.vue'),
  },
  {
    path: '/datav',
    redirect: '/datav/chargeOverview',
    component: FullScreenLayout,
    meta: {
      hideKey: '',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'chargeOverview',
        name: 'chargeOverview',
        component: () => import('@/views/DataV/BigDataMonitor.vue'),
      },
      {
        path: 'stationOverview',
        name: 'stationOverview',
        component: () => import('@/views/DataV/Station/Station.vue'),
      },
      {
        path: 'photovoltaicOverview',
        name: 'photovoltaicOverview',
        component: () => import('@/views/DataV/Photovoltaic/Photovoltaic.vue'),
      },
    ],
  },
  {
    path: '/alarm',
    component: Layout,
    redirect: '/alarm/list',
    meta: {
      hideKey: '',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'list',
        name: 'evseAlarms',
        component: () => import('@/views/Alarm/Alarms.vue'),
      },
      {
        path: 'repository',
        name: 'evseAlarmRepositorys',
        component: () => import('@/views/Alarm/AlarmsRepository.vue'),
      },
    ],
  },
  {
    path: '/evses',
    component: Layout,
    name: 'evses',
    redirect: '/evses/list',
    meta: {
      hideKey: 'evses',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'list',
        name: 'evseList',
        component: () => import('@/views/Evses/Evses.vue'),
      },
      {
        path: 'otas',
        name: 'evseOtas',
        meta: {
          showSubMenu: false,
          hideInMenu: true,
        },
        component: () => import('@/views/Evses/EvseOtas.vue'),
      },
      {
        path: 'models',
        name: 'evseModels',
        meta: {
          showSubMenu: false,
          hideInMenu: true,
        },
        component: () => import('@/views/Evses/EvseModels.vue'),
      },

      {
        path: 'essDevice',
        name: 'essDevice',
        component: () => import('@/views/Evses/EssDevice.vue'),
      },

      {
        path: 'plockList',
        name: 'plockList',
        component: () => import('@/views/Evses/PLocks.vue'),
      },
    ],
  },

  {
    path: '/evse-detail',
    component: Layout,
    meta: {
      hideKey: 'evse-detail',
      authRequired: true,
    },
    children: [
      {
        path: 'evse/:id',
        name: 'evse-detail',
        meta: {
          hideInMenu: true,
        },
        component: () => import('@/views/Evses/EvseDetails.vue'),
      },
    ],
  },

  {
    path: '/locations',
    component: Layout,
    meta: {
      hideKey: 'locations',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'locations',
        component: () => import('@/views/Stations/Stations.vue'),
      },
      {
        path: 'detail/:id',
        name: 'station-detail',
        component: () => import('@/views/Stations/StationDetails.vue'),
      },
    ],
  },
  {
    path: '/sessions',
    component: Layout,
    meta: {
      hideKey: 'sessions',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'sessions',
        component: () => import('@/views/Orders/Orders.vue'),
      },
      {
        path: 'detail/:id',
        name: 'order-detail',
        component: () => import('@/views/Orders/OrderDetails.vue'),
      },
    ],
  },
  {
    path: '/occupy',
    component: Layout,
    meta: {
      hideKey: 'occupy',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'occupyOrder',
        component: () => import('@/views/Orders/Occupy.vue'),
      },
    ],
  },
  {
    path: '/pricing/tariff',
    component: Layout,
    meta: {
      hideKey: 'pricing',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'tariff',
        component: () => import('@/views/Pricing/pricing.vue'),
      },
    ],
  },
  {
    path: '/pricing/activity',
    component: Layout,
    meta: {
      hideKey: 'pricing',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'activity',
        component: () => import('@/views/Pricing/activity.vue'),
      },
    ],
  },
  {
    path: '/reporting',
    component: Layout,
    meta: {
      hideKey: 'reporting',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'reporting',
        component: () => import('@/views/Reporting/Reporting.vue'),
      },
    ],
  },
  {
    path: '/invoice',
    component: Layout,
    meta: {
      hideKey: 'invoice',
      authRequired: true,
      subMenu: true,
    },
    redirect: '/invoice/bizconfigs',
    children: [
      {
        path: 'bizconfigs',
        name: 'invoiceBizList',
        component: () => import('@/views/Invoice/BizConfigs.vue'),
      },
      {
        path: 'applys',
        name: 'invoiceApplyList',
        component: () => import('@/views/Invoice/Applys.vue'),
      },
      {
        path: 'items',
        name: 'invoiceApplyItems',
        component: () => import('@/views/Invoice/ApplyItems.vue'),
      },
    ],
  },
  {
    path: '/profitsharing',
    component: Layout,
    redirect: '/profitsharing/payees',
    meta: {
      hideKey: 'profitsharing',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'strategys',
        name: 'strategyList',
        component: () => import('@/views/ProfitSharing/Strategys.vue'),
      },
      {
        path: 'payees',
        name: 'payeeList',
        component: () => import('@/views/ProfitSharing/Payees.vue'),
      },
      {
        path: 'transactions',
        name: 'pstransactions',
        component: () => import('@/views/ProfitSharing/Transactions.vue'),
      },
      {
        path: 'withdraws',
        name: 'withdrawList',
        component: () => import('@/views/ProfitSharing/Withdraws.vue'),
      },
    ],
  },
  {
    path: '/business',
    component: Layout,
    redirect: '/business/operators',
    meta: {
      hideKey: 'business',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'operators',
        name: 'operators',
        component: () => import('@/views/Operators/Operators.vue'),
      },
      {
        path: 'brands',
        name: 'brands',
        component: () => import('@/views/Operators/Brands.vue'),
      },
      {
        path: 'hlht',
        name: 'hlht',
        component: () => import('@/views/Operators/Hlht.vue'),
      },
    ],
  },
  {
    path: '/brand-detail',
    component: Layout,
    meta: {
      hideKey: 'brand-detail',
      authRequired: true,
    },
    children: [
      {
        path: 'brand/:id',
        name: 'brand-detail',
        meta: {
          hideInMenu: true,
        },
        component: () => import('@/views/Operators/BrandDetail.vue'),
      },
    ],
  },
  {
    path: '/operator-detail',
    component: Layout,
    meta: {
      hideKey: 'operator-detail',
      authRequired: true,
    },
    children: [
      {
        path: 'operator/:id',
        name: 'operator-detail',
        meta: {
          hideInMenu: true,
        },
        component: () => import('@/views/Operators/OperatorDetail.vue'),
      },
    ],
  },
  {
    path: '/drivers',
    component: Layout,
    redirect: '/drivers/group',
    meta: {
      hideKey: 'drivers',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'cards',
        name: 'driverCards',
        component: () => import('@/views/Users/Cards.vue'),
      },
      {
        path: 'users',
        name: 'driverUsers',
        component: () => import('@/views/Users/Users.vue'),
      },
      {
        path: 'group',
        name: 'groupView',
        component: () => import('@/views/Users/Group.vue'),
      },
    ],
  },
  {
    path: '/group-detail',
    component: Layout,
    meta: {
      hideKey: 'group-detail',
      authRequired: true,
    },
    children: [
      {
        path: 'group/:id',
        name: 'group-detail',
        meta: {
          hideInMenu: true,
        },
        component: () => import('@/views/Users/GroupDetail.vue'),
      },
    ],
  },
  {
    path: '/user-detail',
    component: Layout,
    meta: {
      hideKey: 'user-detail',
      authRequired: true,
    },
    children: [
      {
        path: 'user/:id',
        name: 'user-detail',
        meta: {
          hideInMenu: true,
        },
        component: () => import('@/views/Users/UserDetail.vue'),
      },
    ],
  },
  {
    path: '/support',
    component: Layout,
    redirect: '/support/feedback',
    meta: {
      hideKey: '',
      authRequired: true,
      subMenu: true,
    },
    children: [
      {
        path: 'feedback',
        name: 'supportFB',
        component: () => import('@/views/Support/Feedback.vue'),
      },
      {
        path: 'qaa',
        name: 'supportFAQ',
        component: () => import('@/views/Support/Qaa.vue'),
      },
      {
        path: 'roadRescue',
        name: 'supportRescueOrder',
        component: () => import('@/views/Support/roadRescue.vue'),
      },
      {
        path: 'rescueConfig',
        name: 'supportRescueConfig',
        component: () => import('@/views/Support/roadRescueConfig.vue'),
      },
      {
        path: 'cooperation',
        name: 'supportCooperation',
        component: () => import('@/views/Support/Cooperation.vue'),
      },
    ],
  },
  {
    path: '/managers',
    component: Layout,
    meta: {
      hideKey: 'managers',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'managers',
        component: () => import('@/views/Managers/Managers.vue'),
      },
    ],
  },
  {
    path: '/roles',
    component: Layout,
    meta: {
      hideKey: 'roles',
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'roles',
        component: () => import('@/views/Roles/Roles.vue'),
      },
    ],
  },
  {
    path: '/sso',
    name: 'sso-login',
    component: () => import('@/views/Base/SSOLogin.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: Layout,
    meta: {},
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@/views/Base/NotFound.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const { fullPath, meta, path } = to
  const { authRequired = false } = meta
  const info = store.state.user
  if (authRequired && !info.token) {
    toLogin(fullPath)
    return
  }
  const routerHistory = store.state.routerHistory
  if (!routerHistory.some((item) => item.fullPath === fullPath) && path !== '/login') {
    next()
    await nextTick()
    store.dispatch('addRouteHistory', {
      fullPath,
      name: to.name,
    })
    return
  }
  next()
})

//Logout and go to Login page
export function toLogin(path?: string): void {
  if (router.currentRoute.value.path === '/login') {
    return
  }
  store.commit('UPDATE_USER_INFO', { logOut: true })
  store.commit('UPDATE_EDITION', null)
  store.commit('CLEAR_ABORT_CONTROLLERS') // Cenceled All pending request
  store.commit('UPDATE_LOGIN_BACKEND', null) // Cenceled All pending request
  const currentPath = router.currentRoute.value.path
  currentPath !== '/login' &&
    router.push({
      path: '/login',
      // query: { to: path ? path : currentPath ?? undefined },
    })
}

export default router
